/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const campaignBudgetBreakdownDataSchema = z.object({
	metaBudget: z.number(),
	serviceFee: z.number(),
})

export type CampaignBudgetBreakdownDataSchema = z.infer<typeof campaignBudgetBreakdownDataSchema>
